;(function(){

	var $collectables = $('#collectables');

	if( $collectables.length > 0 && site.width >= 560 ){

		var videoHtml = '<video muted loop type="video/mp4"></video>';

		$collectables
			.find('.video-wrapper')
			.each(function(){

				var $this = $(this),
					data = $this.data();

				var $video = $(videoHtml);

				if( !data.autoplay ){

					$this
						.on('mouseenter mouseleave', function(e){

							var over = e.type == 'mouseenter';

							if( over )
								$video[0].play();

							TweenLite
								.to($video, .2, {
									opacity: over ? 1 : 0,
									onComplete: function(){

										if( !over ){
											$video[0].pause();
											$video[0].currentTime = 0;
										}

									}
								});

						});

				}

				$video.attr('src', data.video).attr('autoplay', data.autoplay ? true : false);

				$video.appendTo($this).css('opacity', data.autoplay ? 1 : 0);

			});

	}

}());